var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    { staticClass: "flixel__list", class: { blocks: _vm.gridView } },
    [
      _vm._l(_vm.filteredFlixels, function(flixel, index) {
        return _c(
          "div",
          {
            class: _vm.gridView
              ? "flixel__list--portrait"
              : "flixel__list--landscape"
          },
          [
            _c(
              "li",
              {
                staticClass: "flixel__list--cinemagraph",
                class: { "watermark--border": flixel.selected }
              },
              [
                !_vm.profilePage
                  ? _c("flixelListGallery", {
                      staticClass: "iframe h-cover",
                      attrs: { flixel: flixel, index: index }
                    })
                  : _vm._e(),
                _vm.profilePage
                  ? _c("flixelListProfile", {
                      staticClass: "iframe h-cover",
                      attrs: { flixel: flixel, index: index }
                    })
                  : _vm._e(),
                _vm.returnStatus(flixel.status) !== "complete"
                  ? _c(
                      "div",
                      { staticClass: "h-cover" },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "background list--shadow h-textcenter"
                          },
                          [
                            _vm.returnStatus(flixel.status) !== "complete" &&
                            _vm.returnStatus(flixel.status) !== "failed"
                              ? _c("p", [
                                  _vm._v("We are processing your cinemagraph.")
                                ])
                              : _vm._e(),
                            _vm.returnStatus(flixel.status) === "failed"
                              ? _c("p", [
                                  _vm._v(
                                    "We could not process your cinemagraph. "
                                  ),
                                  _c("br"),
                                  _vm._v(" Please try uploading again.")
                                ])
                              : _vm._e()
                          ]
                        ),
                        _c("router-link", {
                          staticClass: "link_ovelay",
                          attrs: {
                            to:
                              "{name: 'Flixel', params: { hash: flixel.hash } }"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            ),
            !_vm.profilepage
              ? _c(
                  "div",
                  { staticClass: "flixel__list--accreditation" },
                  [
                    _c(
                      "router-link",
                      {
                        attrs: {
                          to: {
                            name: "Profile",
                            params: { username: flixel.username }
                          }
                        }
                      },
                      [
                        _c("div", { staticClass: "accreditation__item" }, [
                          flixel.user_avatar
                            ? _c("img", { attrs: { src: flixel.user_avatar } })
                            : _vm._e(),
                          _c("p", [_vm._v(_vm._s(flixel.username))])
                        ])
                      ]
                    )
                  ],
                  1
                )
              : _vm._e(),
            !_vm.isLoading && _vm.flixelsObj.count === 0
              ? _c("p", [_vm._v("No cinemagraphs found.")])
              : _vm._e()
          ]
        )
      }),
      _vm.isLoading ? _c("div", { staticClass: "row" }, [_vm._m(0)]) : _vm._e()
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "columns small-12" }, [
      _c("div", { staticClass: "loading__lazy" }, [
        _c("div", { staticClass: "spinner" })
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f06e506c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f06e506c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FlixelList.vue
// module id = null
// module chunks = 